// extracted by mini-css-extract-plugin
export default {"card":"category_card__Vnh5W"};